import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTICIPANTS_QUERIES } from "~/shared/api/participants/participants.queries";

export function participantViewLoader(queryClient: QueryClient, { params }: LoaderFunctionArgs) {
  const { participantId } = params;

  if (!participantId) {
    throw new Error("Participant ID is required to load participant");
  }

  queryClient.prefetchQuery(PARTICIPANTS_QUERIES.participant(participantId)).catch(() => {
    // Ignore errors and handle them in the component error boundary instead
    return null;
  });

  return null;
}
